/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: hao, william jiang
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Router } from "react-router-dom";

import AppHeader from "../../../shared/AppHeader";
import AppFooter from "../../../shared/AppFooter";
// import SideMenu from '../../../shared/SideMenu';
import PageOverlay from "../../../shared/PageOverlay";
import Loading from "../../../shared/Loading";
import Routers from "../../../router/router";
import UtagData from "../../../config/tagging";
import {
  changeLanguage,
  menuAction,
  saveAppInfo,
  retrvApp,
  clearError,
  getAppMessage
} from "../state/action";
import paths from "../../../config/path";
import history from "../../../utils/history";
import { getUserAgent, 
  getSessionDatas, 
  isStringEmpty, 
  taggingHandler, 
  getDefaultTagging,
  isEqual
} from "../../../utils";
// import { apiMap, settings } from '../../../config/constants';
import SystemErrorMsg from "../../../shared/SystemErrorMsg/index";
import HiddenAttrs from '../../../shared/HiddenAttrs'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: history.location.pathname,
      languageMenuIsOpen: false
    };
    // 0: initial 1: inprogress 2: frozen 3: rejected 4: reset
    this.proceedUrl = {
      '0': ['accountOpeningSteps', 'applicantInformation'],
      '1': ['accountOpeningSteps', 'applicantInformation', 'companyRegistration', 'basicInfo', 'accountQuestion', 'previewQuestion'],
      '3': ['confirmPQ'],
      '4': ['dashboard', 'aoform', 'file_upload_info', 'agreement'],
      '2': ['appointment'],
      '5': ['appointment']
    }
    this.taggingHandlerApp();
  }

  componentWillMount() {
    const user_agent = getUserAgent();
    this.ua = {
      OS: user_agent.aOS
        ? " aOS"
        : user_agent.iOS ? " iOS" : user_agent.winPhone ? " winPhone" : "",
      isMobile: user_agent.mobile ? " mobile-mode" : " desktop-mode",
      isDesktopIe: user_agent.msie && !user_agent.mobile ? " msie" : "",
      isiPad: user_agent.iPad ? " iPad" : "",
      isiPhone: user_agent.iPhone ? " iPhone" : ""
    };
  }

  componentDidMount = () => {
    // get message from content server
    this.loadContentMessage();
    const unlisten = history.listen(location => {
      this.setState({
        currentPage: location.pathname
      }, () => {
        if (!this.detectTokenAction()){
          this.props.applicationInfo && this.matchStatusGetUrl(this.props);
          this.taggingHandlerApp();
        }
      });
    });
    this.unlisten = unlisten;
    this.detectTokenAction();
    this.getRetrvAppInfo();
  };
  taggingHandlerApp = () => {
      const subPage = window.location.pathname.slice(1);
      let item = UtagData[subPage];
      if(subPage === 'accountQuestion' && typeof window.info1Tag !== 'undefined') {
          item = Object.assign({}, item, window.info1Tag)
      }
      taggingHandler(item);
  }
  componentWillUnmount = () => {
    this.unlisten();
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (nextProps !== this.props || nextState !== this.props) {
      if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
        this.loadContentMessage();
        return true;
      }
      if (nextProps.app !== undefined) {
        const header = nextProps.app.header;
        this.initNavList(header);
        this.initMenuParams(header, nextState);
      }
      return true;
    } else {
      return false;
    }
  };

  componentWillReceiveProps(nextProps) {
    const { app, showSystemError, errorCode, applicationInfo } = nextProps;
    if (applicationInfo && !isEqual(applicationInfo, this.props.applicationInfo)) {
      this.matchStatusGetUrl(nextProps);
    }
    if (showSystemError && errorCode) {
      this.systemErrorContent = {
        title: { text: app.error_title, dataKey: "SystemErrorTitle" },
        info: [
          {
            text: app.errorMessage[errorCode] || "",
            dataKey: "SystemErrorInfo"
          }
        ],
        closeBtn: { text: app.close, dataKey: "systemErrorMsg.closeBtn.text" }
      };
      // if detect the system error, will scroll window to top
      if (this.props.showSystemError !== showSystemError) {
        this.scrollToTop();
      }
    }
  }
  matchStatusGetUrl = ({applicationInfo}) => {
      const { status, progressIndex } = applicationInfo;
      const subPage = window.location.pathname.split('/')[1] || null;
      if (subPage && subPage !== 'logon' && subPage !== 'systemErrorMessage') {
        const isCurrentStatue = (num, progressIndex) => {
        if (this.proceedUrl[`${num}`].indexOf(subPage) === -1) {
            if (progressIndex || progressIndex === 0) {
              history.replace('/' + this.proceedUrl[`${num}`][progressIndex + 2]);
            } else {
              history.replace('/' + this.proceedUrl[`${num}`][0]);
            }  
          }
        }
        if (status === 1) {
          if (progressIndex === 4) {
            isCurrentStatue('4');
          } else {
            isCurrentStatue('1', progressIndex);
          }
        } else {
          isCurrentStatue(`${status}`);
        }
      }
      
  }
  detectTokenAction = () => {
    const { headerInfo } = getSessionDatas();
    let tempPath = history.location.pathname.replace(/\//, "");
    const pathList = tempPath && tempPath.split("/");
    if (pathList && pathList.length > 0) {
      tempPath = pathList[0];
    }
    if ((paths[tempPath] || paths.logon).needToken) {
      if (headerInfo === undefined || headerInfo === null) {
        history.replace(paths.logon.path);
        return true;
      }
    }
    return false
  }

  scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  onLanguageDidChange = lang => {
    this.props.changeLanguage(lang);

    const p = getDefaultTagging();
    taggingHandler({
      ...p,
      page_language: lang
    });
  };

  onLanguageMenuToggle = (isOpen, event, source) => {
    this.setState({ languageMenuIsOpen: isOpen });
  };

  redirectToHelp = () => {
    window.open(paths.help.path);
  };

  redirectToHome = () => {
    history.push(paths.root.path);
  };

  loadContentMessage = () => {
    this.props.getAppMessage();
  };

  getRetrvAppInfo = () => {
    const rbbInfo = getSessionDatas();
    const { currentPage } = this.state;

    let tempPath = currentPage && currentPage.replace(/\//, "");
    const pathList = tempPath && tempPath.split("/");
    if (pathList && pathList.length > 0) {
      tempPath = pathList[0];
    }
    const page = paths[tempPath];
    const isGetAppInfo =
      !this.props.applicationInfo &&
      (page && page.id > 0) &&
      !isStringEmpty(rbbInfo.applicationId);
    isGetAppInfo && this.props.retrvApp(rbbInfo.applicationId);
  };

  initNavList = header => {
    this.navList = [
      /*{
                id: 'home',
                name: header.home,
                action: this.redirectToHome,
                path: [paths.root.path]/!*[paths.logon.path, paths.root.path]*!/
            },*/
      {
        id: "help",
        name: header.help,
        action: this.redirectToHelp,
        path: paths.help.path
      }
    ];
  };

  initMenuParams = (header, nextState) => {
    this.menuParams = {
      menuAction: this.props.menuAction,
      onLanguageDidChange: this.onLanguageDidChange,
      currentPage: nextState.currentPage,
      currentLanguage: this.props.selectedLanguage,
      pageNavList: this.navList,
      languages: header.languages,
      headerDataId: "App-AppHeader-CommonHeader",
      sideMenuDataId: "App-SideMenu-MobileSideMenu",
      onLanguageMenuToggle: this.onLanguageMenuToggle,
      languageMenuIsOpen: nextState.languageMenuIsOpen
    };
  };

  // initSystemError = (header, nextState) => {
  //     this.systemErrorContent = {
  //         title: {text: 'System error', dataKey: 'SystemErrorTitle'},
  //         info: [
  //             { text: 'Reference code is not correct (RBB012-04).  Please retry.', dataKey: 'SystemErrorInfo1' },
  //             { text: 'The operating system returned the error (RBB012-05).  Please try again.', dataKey: 'SystemErrorInfo2' }
  //         ],
  //         closeBtn: {text: 'Close', dataKey: 'systemErrorMsg.closeBtn.text'}
  //     }
  // };

  closeSystemError = () => {
    const { clearError } = this.props;
    clearError && clearError();
  };
  getUserId = () => {
    let userId = getSessionDatas().userId || '';
    let applicationId = getSessionDatas().applicationId || '';
    if (window.location.pathname === '/logon' || window.location.pathname === '/') {
      userId = '';
      applicationId = '';
    }
    return {userId, applicationId};
  }
  render() {
    const {
      isOpen,
      app,
      selectedLanguage,
      isLoading,
      showSystemError
    } = this.props;
    return app
      ? <Router history={history}>
        <div
          className={`App${isOpen ? " side-menu-on" : ""}${this.ua.OS}${this
            .ua.isMobile}${this.ua.isDesktopIe}${this.ua.isiPad}${this.ua
              .isiPhone}`}
          data-lang={selectedLanguage}
        >
          <div id="main" className="app-container">
            <Loading.FullScreenLoading
              show={isLoading}
              content={{ text: app.loading, dataKey: "FullScreenLoading" }}
            />
            {showSystemError
              ? <SystemErrorMsg
                content={this.systemErrorContent}
                closeSystemError={this.closeSystemError}
              />
              : null}
            <AppHeader params={this.menuParams} />
            <div className="page-wrapper">
              <Routers selectedLanguage={selectedLanguage} />
              <AppFooter
                value={app.footer}
                dataId={"App-AppFooter-CommonFooter"}
                params={this.menuParams}
              />
              <HiddenAttrs {...this.getUserId()} />
              <PageOverlay dataId={"App-PageOverlay-PageContentDim"} />
            </div>
          </div>
          <div className="trays">
            {/*<SideMenu
                            params={this.menuParams}
                        />*/}
          </div>
        </div>
      </Router>
      : null;
  }
}

const mapStateToProps = state => {
  const {
    app: {
      isOpen,
      selectedLanguage,
      applicationInfo,
      isLoading,
      i18n,
      showSystemError,
      errorCode
    }
  } = state;
  return {
    isOpen,
    app: i18n,
    selectedLanguage,
    applicationInfo,
    isLoading,
    showSystemError,
    errorCode
  };
};

export default connect(mapStateToProps, {
  changeLanguage,
  menuAction,
  saveAppInfo,
  getAppMessage,
  retrvApp,
  clearError
})(App);



// WEBPACK FOOTER //
// ./src/views/App/container/index.js